import { render, staticRenderFns } from "./ConfirmationAccount.vue?vue&type=template&id=15f3330b"
import script from "./ConfirmationAccount.vue?vue&type=script&lang=js"
export * from "./ConfirmationAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports